import { connect } from 'scrivito'

import { CellRendererParams } from '../EntityTable/types'
import { DataClassName } from '@/Data/const'
import { ContactListRelation } from '@/Data/ContactListRelation/ContactListRelationDataClass'

export const ListItemsCountCell = connect(
  ({ dataItem }: CellRendererParams) => {
    const contactEntity =
      dataItem.get('entityType') === DataClassName.COMPANY
        ? DataClassName.COMPANY
        : DataClassName.PERSON

    const itemsCount =
      ContactListRelation.all()
        .transform({
          filters: {
            list: dataItem.id(),
            contactEntity,
          },
        })
        .count() ?? 0

    return Intl.NumberFormat().format(itemsCount)
  },
)
